import styled from 'styled-components';
import { token, textStyles } from '@bynder/design-system';
import { IconClear, IconFile } from '@bynder/icons';

export const ModalContent = {
	Container: styled.div`
		margin-left: ${token.spacing4};
		margin-bottom: ${token.spacing4};
		width: 100%;
	`,
	H1: styled.h1`
		${textStyles.headingM}
		padding-bottom: ${token.spacing4}
	`,
	H2: styled.h2`
		${textStyles.headingS}
	`,
	P: styled.p`
		${textStyles.paragraphM}
		margin: 0;
	`,
	PGrey: styled.p`
		${textStyles.paragraphM}
		color: ${token.gray500};
	`,
	Strong: styled.strong`
		font-weight: 600;
	`,
	Hr: styled.hr`
		border-top: 1px solid ${token.gray100};
	`,
	BadgeContainer: styled.div`
		display: flex;
		justify-content: space-between;
	`,
};

export const CloseIcon = styled(IconClear)`
	width: 16px;
	height: 16px;
`;

export const ContentContainer = styled.div`
	display: flex;
	flex-direction: column;
`;

export const ResultsContainer = styled.div`
	display: flex;
	width: calc(400px + 32px); /* input width + padding on sides . take 100% width*/
	z-index: 100;
	border: 1px solid #d9dee1;
	border-radius: ${token.radiusMedium};
	box-shadow: 0 1px 6px 0 rgb(0 0 0 / 5%);
	box-sizing: border-box;
	background-color: ${token.white};
	flex-direction: column;
`;

export const ListItemContainer = styled.div`
	display: flex;
	justify-content: space-between;
	padding: ${token.spacing2} ${token.spacing5};
	align-items: center;
	&:hover {
		cursor: pointer;
	}
`;

export const Content = styled.div`
	display: flex;
	align-items: center;
`;

export const AssetDetails = styled.p`
	color: rgba(0, 34, 51, 0.5);
	font-size: ${token.fontSize50};
	margin: ${token.spacing1};
	margin-left: ${token.spacing4};
	${ListItemContainer}:hover & {
		color: ${token.blue1000};
	}
`;

export const AssetExtension = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: ${token.gray400a};
	color: ${token.white};
	border-radius: ${token.radiusBase};
	text-transform: uppercase;
	font-size: ${token.fontSize50};
	width: 30px;
	height: 20px;
`;

export const GuidesIcon = styled(IconFile)`
	width: 24px;
	height: 24px;
`;

export const StyledSearchItem = styled.li<{ isItemSelected: boolean }>`
	position: relative;
	padding: 4px 8px;

	&:hover {
		background-color: ${token.gray25};
	}

	${({ isItemSelected }) => isItemSelected && `background-color: ${token.gray25};`}
`;
